import { ErrorResponseSchema } from "@albertine/types/openapi/concierge-v1";

export function assertNever(value: never): never {
    throw new Error(`Unhandled value: ${JSON.stringify(value)}`);
}

export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }

    const apiError = ErrorResponseSchema.safeParse(error);
    if (apiError.success) {
        return apiError.data.error;
    }

    return "Unknown chat error";
}
